/**
 * QMS 前端应用入口
 *
 * 初始化 Vue 应用，挂载 Pinia 与 Vue Router，导入全局样式
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

// 全局样式（TailwindCSS 指令 + CSS 变量主题）
import './assets/styles/globals.css';

const app = createApp(App);

// 状态管理
app.use(createPinia());

// 路由
app.use(router);

// 挂载应用
app.mount('#app');
